export default "__VITE_ASSET__DA8p6FVP__"